import React from "react"
import { Toolbar, Divider, Typography, Grid, Box } from "@mui/material"
import LocationOnIcon from "@mui/icons-material/LocationOn"

import  { divDivider, locationIcon, locationText, titleText } from "./styles/TitleStyles"

function Title({ location }) {
    

    return (
        <div>
            <Toolbar sx={titleText}>What can we help you with?</Toolbar>
            <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                <LocationOnIcon sx={locationIcon} />
                <Typography sx={locationText}>{location} Conference Room</Typography>
            </Grid>
            <Box sx={divDivider}>
                <Divider />
            </Box>
        </div>
    )
}

export default Title
